import { useCallback, useState } from 'react';

import { handleResponse } from 'utils/hooks/api/utils';
import { ApiResponse } from 'services/api';

export const useInsightsResponseHandler = <QueryT>() => {
  const [data, setData] = useState<QueryT | undefined>();
  const [isRetrying, setIsRetrying] = useState(false);

  const responseHandler = useCallback((response: ApiResponse<QueryT>) => {
    setData((prevData) => ({ ...prevData, ...response.data }));
    setIsRetrying(response.status === 206);
    return handleResponse(response);
  }, []);

  return {
    data,
    isRetrying,
    handleResponse: responseHandler,
  };
};
